module.exports = __webpack_public_path__ + "static/media/team.f2b8bbc8.png";